/**
 * Formats a countdown for display, coarsening precision as the remaining
 * time grows so a multi-day countdown doesn't show useless seconds:
 *
 *   >= 1 day     -> "3d"
 *   >= 1 hour    -> "14h 02m"
 *   >= 5 minutes -> "12m"
 *   otherwise    -> "4:32" / "0:09"
 *
 * Anything at or below zero reads as "0:00" rather than a negative value.
 */
export function formatCountdown(ms: number): string {
  if (ms <= 0) {
    return '0:00';
  }

  const totalSeconds = Math.floor(ms / 1000);

  const days = Math.floor(totalSeconds / 86400);
  if (days >= 1) {
    return `${days}d`;
  }

  const hours = Math.floor(totalSeconds / 3600);
  if (hours >= 1) {
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return `${hours}h ${String(minutes).padStart(2, '0')}m`;
  }

  const minutes = Math.floor(totalSeconds / 60);
  if (minutes >= 5) {
    return `${minutes}m`;
  }

  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
}
